{
  "manager": {
    "audienceCreator": {
      "title": "Audience",
      "include": "Include",
      "exclude": "Exclude"
    },
    "audienceFilterPicker": {
      "filterCategories": "Filter categories",
      "whatAreYouAdding": "What are you adding?",
      "noCategoriesMatch": "No categories match \"{query}\".",
      "allCategories": "All categories",
      "loadError": "Couldn't load {type}. Check your connection and try again.",
      "selectAllRegOps": "Select all {count} reg. ops",
      "noMatches": "No matches."
    },
    "audienceRecipientPreview": {
      "pickWhoToReach": "Pick who you want to reach below.",
      "sendingTo": "Sending to",
      "except": "except",
      "noRecipients": "No recipients selected — all groups are excluded."
    }
  }
}
